export const theme = {
  colors: {
    bg: '#0A0A0A',
    surface1: '#111111',
    surface2: '#161616',
    surface3: '#1E1E1E',
    primary: '#F47920',
    primaryHover: '#FF8C3A',
    primaryDark: '#C5601A',
    primaryGlow: 'rgba(244, 121, 32, 0.25)',
    white: '#FFFFFF',
    text: '#FFFFFF',
    textSecondary: '#B3B3B3',
    textMuted: '#555555',
    border: '#252525',
    borderAccent: 'rgba(244, 121, 32, 0.25)',
  },
  fonts: {
    heading: "'Barlow Condensed', sans-serif",
    body: "'DM Sans', sans-serif",
  },
  transitions: {
    fast: '150ms ease',
    normal: '250ms ease',
    slow: '400ms ease',
  },
  shadows: {
    orange: '0 0 40px rgba(244, 121, 32, 0.3)',
    orangeStrong: '0 0 80px rgba(244, 121, 32, 0.4)',
    card: '0 4px 30px rgba(0, 0, 0, 0.5)',
  },
};
